var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Table Test")]),_c('VueGoodTable',_vm._b({scopedSlots:_vm._u([{key:"table-column",fn:function({ column }){return [_c('VTableHeader',{attrs:{"columns":_vm.table.columns,"column":column}}),_vm._v(" "+_vm._s(column.sortable ? ' Sortable' : ' Not Sortable')+" ")]}}])},'VueGoodTable',_vm.table,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }